import { FormikTouched, FormikErrors } from 'formik'
import { useState, useEffect } from 'react'
import { Flex, Box, Text, Heading, Card } from 'rebass/styled-components'
import { IProperties } from '../../../builder/types'
import FormField from '../../../../../components/FormField'
import Select from 'react-select'

interface IFillingDropdownProps {
  properties: IProperties,
  name: string,
  touched: FormikTouched<any>,
  errors: FormikErrors<any>,
  values: any,
  disabled?:boolean
  setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void
  setFieldTouched: (field: string, isTouched?: boolean | undefined, shouldValidate?: boolean | undefined) => void
}

export const FillingDropdown: React.FC<IFillingDropdownProps> = ({ properties, values, setFieldValue, name, touched, errors, setFieldTouched, disabled }) => {
  return (
    <Flex flex={1}>
      <Flex flexDirection={'column'} flex={1 / 4}>
        <Text onClick={() => { }} fontWeight={500} style={{userSelect: 'none'}}>
          {`${((properties || {}).params || {}).question || 'Question'}${(((properties || {}).params || {}).ctrlProps || {}).required ? '*' : ''}`}
        </Text>
        <Text fontSize={'12px'} fontWeight={300} style={{userSelect: 'none'}}>
          {((properties || {}).params || {}).description || ''}
        </Text>
      </Flex>
      <Flex ml={3} flex={1} justifyContent={'flex-start'}>
        <div style={{ maxWidth: '500px', alignSelf: 'center', width: '100%' }}>
          <FormField flex={1} mb={0} error={touched[name] && errors[name]}>
            <Select
              className="custom_zindex"
              classNamePrefix="region-select"
              {...((properties || {}).params || {}).ctrlProps}
              styles={{
                // minWidth: '400px',
                menu: (provided) => ({ ...provided, zIndex: 9999 }),
              }}
              onBlur={() => {
                if (!values[name]) setFieldValue(name, '');
                setFieldTouched(name, true);
              }}
              isDisabled={disabled}
              value={((((properties || {}).params || {}).ctrlProps || {}).options || []).find((x) => x.label === values[name])}
              onChange={(e: any) => setFieldValue(name, e.label)}
              noOptionsMessage={() => (
                <div style={{ padding: '12px 24px' }}>
                  <Text textAlign="left" mb={2} fontSize="16px" fontWeight="400">
                    No options set
                  </Text>
                </div>
              )}
              theme={(base) => ({
                ...base,
                colors: {
                  ...base.colors,
                  primary: '#364f79',
                  primary50: '#dae6fa',
                },
              })}
            />
          </FormField>
        </div>
      </Flex>
    </Flex>);
}